import { render, staticRenderFns } from "./DrawingView.vue?vue&type=template&id=a64d6cc0&"
import script from "./DrawingView.vue?vue&type=script&lang=js&"
export * from "./DrawingView.vue?vue&type=script&lang=js&"
import style0 from "./DrawingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports